// Funil real (5 etapas): Solicitada → Aprovada → Enviada → Aguardando
// pagamento → Recebido. 'Aguardando pagamento' e o estado apos o cliente
// confirmar que recebeu a NF (documento); 'Recebido' e apos o dinheiro
// entrar na nossa conta (equipe interna marca).
export const STATUS_LIST = ['Solicitada', 'Aprovada', 'Enviada', 'Aguardando pagamento', 'Recebido', 'Atrasado', 'Cancelada'];
export const IMPOSTOS_LIST = ['Sem retenção', 'PIS', 'COFINS', 'CSLL', 'IR', 'INSS', 'ISS'];

// =============================================================================
// LINKS PARA OS APPS ANTIGOS — modo PRINCIPAL (sem replica)
// =============================================================================
// Cada empresa do grupo tinha seu proprio app antigo. No menu lateral do
// Principal, listamos todos eles como "versão anterior" daquela empresa,
// usando icone de nota (FileText).
//
// Cada replica tem seu proprio legacyUrl em src/lib/replicas.config.js.
// Esta lista aqui so aparece no Principal (fora de qualquer replica).
//
// Troque cada placeholder 'ei johnny' pela URL real (deve comecar com
// http:// ou https://). Se ficar com o placeholder, o item nao aparece
// na sidebar — entao da pra liberar um a um conforme for tendo as URLs.
// =============================================================================
export const LEGACY_APPS = [
  { label: 'Corban',     url: 'https://www.appsheet.com/start/a69c5e8a-ef0e-49b4-9689-66edd970b4b0' },
  { label: "LLC's",      url: 'https://www.appsheet.com/start/d9c1c439-babe-4c1b-a374-b41706ba8c76' },
  { label: 'Bhaz',       url: 'https://www.appsheet.com/start/5737c9c9-d987-4d0b-9d28-c36d844c54d0' },
  { label: 'Evolution',  url: 'https://www.appsheet.com/start/c4ce667e-9cef-422d-958c-24d63ab37d56' },
  { label: 'Plusdin',    url: 'https://www.appsheet.com/start/02edcadb-70ab-4dee-baaf-7cfc063fd6b7' },
  { label: 'Etus',       url: 'https://www.appsheet.com/start/f3981d48-7f8b-419f-8074-f0d3ca02a971' },
  { label: 'Supersonic', url: 'https://www.appsheet.com/start/630f16be-13a7-453b-83d5-2c884fb8d068' },
];

// =============================================================================
// ONBOARDING — apresentacao de treinamento no menu lateral (Principal)
// =============================================================================
// HTML estatico hospedado em /public. Caminho relativo (mesmo dominio)
// OU URL absoluta — o Sidebar aceita ambos. Para configurar onboarding
// por replica, use o campo onboardingUrl em replicas.config.js.
// =============================================================================
export const PRINCIPAL_ONBOARDING_URL = '/onboarding-principal.html';

// Logo do app (sidebar). ID de arquivo publico no Google Drive.
export const APP_LOGO_DRIVE_ID = '1UyakxtiKNLQuUUcWi-tm3nI5Q8sXbNBh';
// Favicon (icone da aba do navegador)
export const APP_FAVICON_DRIVE_ID = '1UAC20cxt1Qekpe8BpC0r71mHuYWF_Q3r';

// Paletas de cor do espelho da NF (cada empresa escolhe uma)
export const ESPELHO_THEMES = {
  azul:    { main: '#1d4ed8', dark: '#1e3a8a', soft: '#eff6ff', line: '#bfdbfe' },
  verde:   { main: '#059669', dark: '#064e3b', soft: '#ecfdf5', line: '#a7f3d0' },
  laranja: { main: '#ea580c', dark: '#7c2d12', soft: '#fff7ed', line: '#fed7aa' },
  preto:   { main: '#18181b', dark: '#09090b', soft: '#f4f4f5', line: '#d4d4d8' },
};
export const ESPELHO_THEMES_ORDER = ['azul', 'verde', 'laranja', 'preto'];

// Paleta de accent do APP (sidebar/buttons/glow). Aplicada quando rodando
// em modo replica e a empresa tem tema_cor definido. Cada paleta espelha
// as variaveis --primary*/--shadow-glow/--bg-image do globals.css.
//
// IMPORTANTE: o texto de .btn-primary e fixo em #0A0A0A, entao a cor
// 'primary' precisa ter contraste suficiente com texto preto.
export const APP_THEMES = {
  azul: {
    primary:        '#3B82F6',
    primary2:       '#2563EB',
    primarySoft:    'rgba(59, 130, 246, 0.10)',
    primarySoft2:   'rgba(59, 130, 246, 0.20)',
    primaryLine:    'rgba(59, 130, 246, 0.30)',
    glow:           'rgba(59, 130, 246, 0.15)',
    bgImage1:       'rgba(59, 130, 246, 0.04)',
    bgImage2:       'rgba(59, 130, 246, 0.025)',
  },
  verde: {
    primary:        '#00CC44',
    primary2:       '#009933',
    primarySoft:    'rgba(0, 204, 68, 0.10)',
    primarySoft2:   'rgba(0, 204, 68, 0.20)',
    primaryLine:    'rgba(0, 204, 68, 0.30)',
    glow:           'rgba(0, 204, 68, 0.15)',
    bgImage1:       'rgba(0, 204, 68, 0.04)',
    bgImage2:       'rgba(0, 204, 68, 0.025)',
  },
  laranja: {
    primary:        '#F97316',
    primary2:       '#EA580C',
    primarySoft:    'rgba(249, 115, 22, 0.10)',
    primarySoft2:   'rgba(249, 115, 22, 0.20)',
    primaryLine:    'rgba(249, 115, 22, 0.30)',
    glow:           'rgba(249, 115, 22, 0.15)',
    bgImage1:       'rgba(249, 115, 22, 0.04)',
    bgImage2:       'rgba(249, 115, 22, 0.025)',
  },
  preto: {
    // Accent prata/cromo pra empresas com tema preto (texto preto fica legivel)
    primary:        '#E4E4E7',
    primary2:       '#A1A1AA',
    primarySoft:    'rgba(228, 228, 231, 0.10)',
    primarySoft2:   'rgba(228, 228, 231, 0.20)',
    primaryLine:    'rgba(228, 228, 231, 0.30)',
    glow:           'rgba(228, 228, 231, 0.15)',
    bgImage1:       'rgba(228, 228, 231, 0.04)',
    bgImage2:       'rgba(228, 228, 231, 0.025)',
  },
};
